module.exports = __webpack_public_path__ + "img/Emblem.8d39bb12.png";